"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ZENDESK_SUPPORT", {
  enumerable: true,
  get: function () {
    return _constants.default;
  }
});

var _constants = _interopRequireDefault(require("./modules/ZendeskSupport/constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }